import { render, staticRenderFns } from "./PrivacyPolicy.vue?vue&type=template&id=503dbd6f"
import script from "./PrivacyPolicy.vue?vue&type=script&lang=ts"
export * from "./PrivacyPolicy.vue?vue&type=script&lang=ts"
import style0 from "./PrivacyPolicy.vue?vue&type=style&index=0&id=503dbd6f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports